// extracted by mini-css-extract-plugin
export default {"link":"BaseCsvDownloadLink--link--ca9909"};